/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKubernetesEtcd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
        <path d="m12 2.845 3.121 1.802 1.027-1.67 1.704 1.046-.998 1.625 3.074 1.775V11H22v2h-2.072v3.577l-3.074 1.775.998 1.624-1.704 1.048-1.027-1.671L12 21.155l-3.121-1.802-1.027 1.67-1.704-1.046.998-1.625-3.074-1.775V13H2v-2h2.072V7.423l3.074-1.775-.998-1.625 1.704-1.046 1.027 1.67zm0 2.31L6.072 8.577v6.846L12 18.845l5.928-3.422V8.577z" />
      </g>
    </g>
  </Icon>
);
export { SvgKubernetesEtcd as KubernetesEtcd };
